import has from 'lodash/has';
export var hasProperty = function (t, prop) { return has(t, prop); };
